module.exports = {
  title: 'fluid-tab-interaction',
  author: 'Enzo Manuel Mangano',
  date: '2025-01-27',
  slug: 'fluid-tab-interaction',
  tags: ['reanimated', 'expo-blur'],
};
